	/*
	 * Enable click event for the Programs filter buttons
	 */
	exports.setupShortCoursesFilterWidget = function (campusID,WidgetuuID, Defaultfilterby, datePickerLangCode) {
		var lstCategorySelectors= ['#category_' + WidgetuuID],
			lstDateSelectors = ['#dateFrom_' + WidgetuuID, '#dateTo_' + WidgetuuID],
			lstWaitListSelectors = ['#waitlist_' + WidgetuuID];

		// Activate Click event under the filter buttons
		$('#BtnCategory_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);
			ShowHideElements(lstCategorySelectors,lstDateSelectors.concat(lstWaitListSelectors), true);
			refreshShortCoursesFilterWidget(campusID,WidgetuuID,'category',true);
		});

		$('#BtnDate_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);
			ShowHideElements(lstDateSelectors,lstCategorySelectors.concat(lstWaitListSelectors), true);
			refreshShortCoursesFilterWidget(campusID,WidgetuuID,'date',true);
		});

		$('#BtnWaitlist_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);

			ShowHideElements(lstWaitListSelectors,lstDateSelectors.concat(lstCategorySelectors), true);

			//TODO: Don't use the ajax for the waiting list because we want to leave google to index that content (should work in theory...Info from Fusion). Will not work with other search engines... Need to revise it.
			refreshShortCoursesFilterWidget(campusID,WidgetuuID,'waitlist');
		});

		$('#category_' + WidgetuuID).change(function () {
			refreshShortCoursesFilterWidget(campusID,WidgetuuID,'category',true);
		});

		$('#dateFrom_' + WidgetuuID).change(function () {
			refreshShortCoursesFilterWidget(campusID,WidgetuuID,'date',true);
		});

		var today = new Date();
		var now = new Date(Date.UTC.apply(Date,[today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()]))
		var datePickerFrom = $('#dateFrom_' + WidgetuuID)
			.fdatepicker({
				format: 'mm/dd/yyyy',
				language: datePickerLangCode,
				onRender: function (date) {
					return date.valueOf() < now.valueOf() ? 'disabled' : '';
				}
			})
			.on('changeDate', function (ev) {
				if (ev.date.valueOf() > datePickerTo.date.valueOf()) {
					var newDate = new Date(ev.date)
					newDate.setDate(newDate.getDate() + 1);
					datePickerTo.update(newDate);
				}
				datePickerFrom.hide();
				$('#dateTo_' + WidgetuuID)[0].focus();
			})
			.data('datepicker');

		$('#dateFrom_' + WidgetuuID).attr("maxlength", 11);

		$('#dateTo_' + WidgetuuID).change(function () {
			refreshShortCoursesFilterWidget(campusID,WidgetuuID,'date',true);
		});
		var datePickerTo =$('#dateTo_' + WidgetuuID)
			.fdatepicker({
				format: 'mm/dd/yyyy',
				language: datePickerLangCode,
				onRender: function (date) {
					return date.valueOf() <= datePickerFrom.date.valueOf() ? 'disabled' : '';
				}
			})
			.on('changeDate', function (ev) {
				datePickerTo.hide();
			}).data('datepicker');
		$('#dateTo_' + WidgetuuID).attr("maxlength", 11);

		$('#divShortCoursesContainer_' + WidgetuuID + ' .waitingBtn').click(function () {
			//Are you sure you want to add this course?
			if (confirm(jQuery.i18n._(7396))) {
				document.location = '/index.cfm?fa=ProgramsFrontMod.AddWaitingListRequest' +
									'&SEQ_Course=' + $(this).data('id') +
									'&VersionNumber=' + $(this).data('versionnumber');
			}
		});

		window.addEventListener('popstate', function(e) {
			var filterby = (typeof e.state === 'undefined' || e.state == null || e.state.filterby == null) ? 'category' : e.state.filterby;

			  if(filterby == 'category'){
				  $('#BtnCategory_' + WidgetuuID).addClass("selected");
				  $('#BtnDate_' + WidgetuuID).removeClass("selected");
				  ShowHideElements(lstCategorySelectors,lstDateSelectors.concat(lstWaitListSelectors), true);
			  }
			  else{
				  $('#BtnDate_' + WidgetuuID).addClass("selected");
				  $('#BtnCategory_' + WidgetuuID).removeClass("selected");
				  ShowHideElements(lstDateSelectors,lstCategorySelectors.concat(lstWaitListSelectors), true);
			  }
			  refreshShortCoursesFilterWidget(campusID,WidgetuuID,filterby,true);
		},false);

	};

	/*
	 * Refresh the Program/course listing when we change the filters (Campus or category)
	 */
	function refreshShortCoursesFilterWidget(campusID,WidgetuuID,type,ajax) {
		ajax = (ajax === undefined) ? false : ajax;	//set default to false

		var url = window.lcb.config.apiPaths.Programcourses;
		var langID = $("meta[name='language-id']").attr('content');
		var filters = (type == 'waitlist') ? getQueryVariables(['langid','filterby','WebTagChildID','dateFrom','dateTo','waitOnly']) : {};
		filters['filterby'] = type;
		filters['ShowShortCourses'] = 1;
		filters['OrderType'] = 'ShortCourses';
		filters['LangID'] = langID;
		filters['campusID'] = campusID;
		var PageFilters = "";
		var PageAnchor = "#ShortCoursesAnchor";

		switch(type) {
			case "category":
				var category = $('#category_' + WidgetuuID).val();

				if (category.length > 0) {
					filters["WebTagChildID"] = category;
					PageFilters = "WebTagChildID="+category;
				} else if (typeof WebTagChildID !== 'undefined'){
					filters["WebTagChildID"] = WebTagChildID;
					PageFilters += ((PageFilters == "")? "" : "&") + "WebTagChildID="+WebTagChildID;
				}

				break;
			case "date":
				var dateFrom = $('#dateFrom_' + WidgetuuID).val();
				var dateTo   = $('#dateTo_' + WidgetuuID).val();

				if (dateFrom.trim().length > 0) {
					filters["dateFrom"] = dateFrom;
					filters["NextDateFrom"] = dateFrom;
					PageFilters = "dateFrom="+dateFrom;
				}

				if (dateTo.trim().length > 0) {
					filters["dateTo"] = dateTo;
					filters["NextDateTo"] = dateTo;
					PageFilters += ((PageFilters == "")? "" : "&") + "dateTo="+dateTo;
				}

				if (typeof WebTagChildID !== 'undefined') {
					filters["WebTagChildID"] = WebTagChildID;
					PageFilters += ((PageFilters == "")? "" : "&") + "WebTagChildID="+WebTagChildID;
				}

				filters["ignoreFull"] = true;
				PageFilters += ((PageFilters == "")? "" : "&") + "ignoreFull="+true;

				break;
			case "waitlist":
				var previewVariables = getQueryVariables(['fa','seq','pagemode']);

				if ('pagemode' in previewVariables && previewVariables['pagemode'] == 'lcbpreview') {
					filters['fa'] = previewVariables['fa'];
					filters['seq'] = previewVariables['seq'];
					filters['pagemode'] = previewVariables['pagemode'];
					delete filters['langid'];
				}

				break;
		}

		if (ajax) {
			LoadApiData(url, filters, { onSuccess: function(data){
				LoadUnderscoreTemplate(window.lcb.config.templatePaths.ShortCourses, data, {
					onSuccess: function(html){
						LoadTemplateDiv('#divShortCoursesContainer_' + WidgetuuID, html, {
							pagination: false
						});

						var dateFrom = $('#dateFrom_' + WidgetuuID).val();
						var dateTo   = $('#dateTo_' + WidgetuuID).val();
						if (type == 'date' && (dateFrom.length > 0  || dateTo.length > 0) ) {
							if (data.totalResults == 0) {
								$('#divShortCourseNoResults_'+WidgetuuID+' .title').text(jQuery.i18n._(17851));
							} else {
								$('#divShortCourseNoResults_'+WidgetuuID+' .title').text(jQuery.i18n._(17856));
							}
						} else {
							if (data.totalResults == 0) {
								$('#divShortCourseNoResults_'+WidgetuuID+' .title').text(jQuery.i18n._(13307));
							} else {
								$('#divShortCourseNoResults_'+WidgetuuID+' .title').text('');
							}
						}

						$('#divShortCoursesContainer_' + WidgetuuID).find('.PaginationContainer').html(GenPageList(1,data.totalResults,9,12,3, window.location.origin + window.location.pathname +"?filterby=" +filters.filterby + ( PageFilters == "" ? ("") : ("&"+ PageFilters)),PageAnchor));
						$("#dateFrom_" + WidgetuuID).removeClass("error");
						$("#dateTo_" + WidgetuuID).removeClass("error");

						history.pushState({filterby: type}, null,  window.location.pathname +"?filterby=" +filters.filterby + ( PageFilters == "" ? ("") : ("&"+ PageFilters)));
					}
				});
			}, onError: function(data) {
				var errors = JSON.parse(data.responseText).ERRORS;
				if (typeof errors !== 'undefined') {
					if (typeof errors.dateFrom !== 'undefined' && errors.dateFrom == "NOT_DATE") {
						$("#dateFrom_" + WidgetuuID).addClass("error");
					} else {
						$("#dateFrom_" + WidgetuuID).removeClass("error");
					}
					if (typeof errors.dateTo !== 'undefined' && errors.dateTo == "NOT_DATE") {
						$("#dateTo_" + WidgetuuID).addClass("error");
					} else {
						$("#dateTo_" + WidgetuuID).removeClass("error");
					}
				}
			}});
		}
		else {
			if (typeof WebTagChildID !== 'undefined') {
				filters["WebTagChildID"] = WebTagChildID;
			}

			window.location.href = window.location.pathname +'?'+ $.param(filters) + PageAnchor;
		}
	}
